import * as React from "react";
import "./CommonChart.css";
import { renderSankey } from "./d3Sankey";

interface Props {
    comparisonGroup?: string[];
    sankeyData: { nodes, links };
    kl2ModalPathway: {pathway}[];
}

class AwardPathway extends React.Component<Props, {}> {
    sankey: SVGGElement;
    sankeyRef = (node) => this.sankey = node;

    componentDidMount() {
        renderSankey(this.sankey, this.props.sankeyData, { width: 900, height: 600, duration: 500 }, this.props.comparisonGroup)
    }

    componentDidUpdate(prevProps) {
        if (this.props.sankeyData !== prevProps.sankeyData) {
            renderSankey(this.sankey, this.props.sankeyData, { width: 900, height: 600, duration: 500 }, this.props.comparisonGroup)
        }
    }

    render() {
        let pathway;
        if (this.props.kl2ModalPathway.length!==0) {
            pathway = this.props.kl2ModalPathway[0].pathway;
        }
        return (

            <div className="chart-container">
                <h4 className="chart-title">NIH Pathways</h4>
                <p>This diagram represents the progression of KL2 scholars and the selected comparison group(s) toward the R01, charting an NIH-funded pathway. Hover over the image for more details.</p>
                <div style={{ width: '900px', margin: '0 auto', paddingTop: '50px' }}>
                    <svg width="900px" height="600px">
                        <g ref={this.sankeyRef}></g>
                    </svg>
                </div>
            </div>
        );


    }
}


export default AwardPathway;

